module.exports = __webpack_public_path__ + "img/start.fbe852b5.svg";